import { useEffect, useState } from "react";

interface ARMeasurement {
  meters: number;
  inches: number;
  cm: number;
  feet: number;
}

interface GuestARMeasurementOverlayProps {
  socketRef: React.RefObject<any>;
  roomId: string;
}

export function GuestARMeasurementOverlay({
  socketRef,
  roomId,
}: GuestARMeasurementOverlayProps) {
  const [measurement, setMeasurement] = useState<ARMeasurement | null>(null);
  const [showMeasurement, setShowMeasurement] = useState(false);

  useEffect(() => {
    const socket = socketRef.current;
    if (!socket) return;

    // Listen for AR line complete event from guest
    const handleARLineComplete = (data: any) => {
      console.log("📏 Received AR measurement from guest:", data);

      if (data.measurement) {
        setMeasurement(data.measurement);
        setShowMeasurement(true);

        // Auto-hide after 5 seconds
        setTimeout(() => {
          setShowMeasurement(false);
        }, 5000);
      }
    };

    // Listen for AR line clear event
    const handleARLineClear = () => {
      console.log("🗑️ Guest cleared AR measurements");
      setMeasurement(null);
      setShowMeasurement(false);
    };

    socket.on("ar-line-complete", handleARLineComplete);
    socket.on("ar-line-clear", handleARLineClear);

    return () => {
      socket.off("ar-line-complete", handleARLineComplete);
      socket.off("ar-line-clear", handleARLineClear);
    };
  }, [socketRef, roomId]);

  if (!showMeasurement || !measurement) {
    return null;
  }

  return (
    <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-50 pointer-events-none">
      <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-4 rounded-2xl shadow-2xl animate-in fade-in slide-in-from-top duration-300">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <span className="text-2xl">📏</span>
          </div>
          <div>
            <div className="text-xs font-medium opacity-90 uppercase tracking-wide">
              Guest AR Measurement
            </div>
            <div className="text-2xl font-bold">
              {measurement.inches.toFixed(2)}"
            </div>
            <div className="text-sm opacity-90">
              {measurement.cm.toFixed(1)} cm • {measurement.meters.toFixed(3)} m
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
